const normaliseStatus = (status) => (status || "").toString().toLowerCase();

export const onlyActiveSecurityHolds = (holds) => (
    Array.isArray(holds) ? holds.filter(hold => normaliseStatus(hold?.status) === "active") : []
);

export const hasVisiblePaymentInformation = (customer) => (
    Number(customer?.paymentMethodCount || 0) > 0
    || customer?.hasActiveSecurityHold === true
    || (Array.isArray(customer?.paymentMethods) && customer.paymentMethods.length > 0)
    || onlyActiveSecurityHolds(customer?.securityHolds).length > 0
);

// The Payments page is also the place where a signed-in customer can manage future
// payment details. It must therefore remain reachable before the first card or hold
// exists; payment information is a content state, not a navigation permission.
export const isPaymentAreaAvailable = (customer) => (
    hasVisiblePaymentInformation(customer)
    || !!customer?._links?.logout
    || !!customer?._links?.edit
);
